const state = {
    isPastDueFilter: false,

};

const getters = {
    GET_OVER_DUE_FILTER: (state) => {
        return state.isPastDueFilter;
    },
    
    
};


const actions = {

    CLEAR_C_SYSTEM_DEPOSIT_STORE: ({ commit }) => {
        commit('clearCSystemDepositStore');
    },
    SET_OVER_DUE_FILTER: ({ commit }, isOverDue) => {

        commit('saveOverDueFilter', isOverDue);

    },
   
    

};


const mutations = {
    clearCSystemDepositStore: (state) => {
        state.isPastDueFilter = false;
   
       
    },

   
    saveOverDueFilter: (state, isOverDue) => {
        state.isPastDueFilter = isOverDue;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}